module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"FinGreeting":{"you_are_archetype_type":"Du bist der Anlegertyp"}},"en":{"FinGreeting":{"you_are_archetype_type":"You\u0027re the investor type"}}}')
  delete Component.options._Ctor
}
